/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PermissionResponse } from './permission-response';

export interface PermissionGroupResponse {
  id: number;
  name: string;
  permissions: Array<PermissionResponse>;
}
